import * as React from "react";
import { ReactNode } from "react";

import { permissions } from "../../../biot/roles";
import { useAuth } from "../../context";

export const Restricted: React.FC<React.PropsWithChildren<{ fallback?: ReactNode; permits: permissions }>> = ({
  fallback,
  permits,
  children,
}) => {
  const [{ isPermitted }] = useAuth();
  return isPermitted(permits) ? <>{children}</> : <>{fallback}</>;
};
